// Underperforming states for 8/15 Consumer Offer Refresh
export const UNDERPERFORMING_STATES = ["WI", "IL", "MN", "TN", "IN", "SC", "NC", "WV"] as const;

export type UnderperformingState = (typeof UNDERPERFORMING_STATES)[number];

// Display networks
export const DISPLAY_SOURCES = ["ttd", "discovery", "taboola", "gdn", "dv360", "yahoodsp", "youtube"];
// Social networks
export const SOCIAL_SOURCES = ["fb", "tw", "reddit", "snapchat", "tiktok"];

export const VERIZON_OFFER_TEXT = "verizon mobile";
